/**
 * @returns true if the value is neither null nor undefined. Useful when used as part of an Array#filter.
 */
export function isPresent<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}
